var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88082 23.9974C0.842449 23.9974 0 23.1235 0 22.0468V6.52796C0 5.45384 0.844898 4.57737 1.88082 4.57737H6.55347V6.07022H1.88082C1.61878 6.07022 1.40327 6.27568 1.40327 6.52796V22.0468C1.40327 22.2991 1.61633 22.5046 1.88082 22.5046H20.8653C21.1298 22.5046 21.3429 22.2991 21.3429 22.0468V16.4811H22.7486V22.0494C22.7486 23.1235 21.9037 24 20.8653 24H1.88082V23.9974ZM9.87673 18.6164C9.86939 18.5748 9.20571 14.2315 11.8849 10.1534C13.7633 7.29519 16.8318 5.3342 21.0098 4.3199L15.9184 1.39402L16.6286 0L24 4.23407L19.6849 11.4772L18.4237 10.6294L21.2473 5.88817C17.498 6.81404 14.7673 8.54876 13.1192 11.0455C11.951 12.8166 11.5347 14.7334 11.3951 16.026C11.2433 17.4148 11.3608 18.4161 11.3731 18.528L11.4024 18.7828L9.90857 18.8036L9.87673 18.6164ZM10.0849 18.5748C10.0531 18.4005 9.4751 14.2133 12.0588 10.2809C14.111 7.15995 17.6057 5.12874 22.4449 4.24447L22.6261 5.36541C18.0857 6.19506 14.831 8.06242 12.9453 10.9181C10.6139 14.4525 11.1575 18.5228 11.1624 18.5618L10.0849 18.5748ZM19.6188 11.1678L18.7151 10.5592L22.1829 4.73602L16.2073 1.30299L16.7167 0.304291L23.7012 4.3173L19.6188 11.1678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.90cbc1bc6667ccd95c23e60a0da8c7a7.svg";
export { ForwardRef as ReactComponent };